import SaveData from "../save-load/SaveData";
import LoadData from "../save-load/LoadData";
// Made for giving standard settings to new users without

function StandardSettings() {
  if (LoadData("Settings") !== "version 0.13") {
    // Changes
    SaveData("Settings", "version 0.13");

    // for SMHIWarningSettings
    SaveData("SMHIWarningSettings", []);

    SaveData("Grid", []);

    SaveData("Tile", []);

    SaveData("FirstTime", true);

    SaveData("Duplicate", false);
  }
}

export default StandardSettings;
